var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgComment = function SvgComment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "var(--native-icon-fill)",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.319 4.465c.211-.485.52-.926.91-1.297.39-.371.854-.665 1.364-.866C4.103 2.102 4.649 2 5.2 2h5.6C13.12 2 15 3.797 15 5.996V14H5.2C2.88 14 1 12.203 1 10.004V5.996c0-.525.108-1.045.319-1.53ZM13.6 5.996a2.607 2.607 0 0 0-.822-1.882 2.875 2.875 0 0 0-1.978-.78H5.2c-.368-.002-.732.067-1.072.2-.34.134-.648.33-.908.577-.26.247-.467.541-.608.865a2.55 2.55 0 0 0-.212 1.02v4.008c.002.706.298 1.383.822 1.882.525.5 1.236.78 1.978.78h8.4v-6.67Zm-2.8 1.337v1.334H9.4V7.333h1.4Zm-4.2 0v1.334H5.2V7.333h1.4Z"
  })));
};

export default SvgComment;